export const CONSENT_COOKIE = "agnos_cookie_consent"
